import { Box, Button, Stack, Typography } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

interface Props {
  crumbLabel: string;
  title: string;
  subtitle: string;
  saveLabel: string;
  onCancel: () => void;
  isSubmitting: boolean;
}

export default function FlashFormHeader({
  crumbLabel,
  title,
  subtitle,
  saveLabel,
  onCancel,
  isSubmitting,
}: Props) {
  return (
    <Box mb={3} width="100%">
      <Stack
        direction="row"
        alignItems="center"
        gap={0.5}
        mb={1}
        color="text.secondary">
        <Box
          component="button"
          type="button"
          onClick={onCancel}
          sx={{
            background: 'none',
            border: 0,
            p: 0,
            cursor: 'pointer',
            color: 'text.secondary',
            transition: 'color 0.12s',
            '&:hover': { color: 'common.black' },
            typography: 'h5',
          }}>
          Shop Flash
        </Box>
        <ChevronRightIcon sx={{ fontSize: 14 }} />
        <Typography variant="h5" color="text.secondary">
          {crumbLabel}
        </Typography>
      </Stack>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        gap={2}>
        <Typography variant="h1" lineHeight={1}>
          {title}
        </Typography>
        <Stack direction="row" gap={1.5} alignItems="center" flexShrink={0}>
          <Button variant="light" onClick={onCancel} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button type="submit" variant="base" disabled={isSubmitting}>
            {saveLabel}
          </Button>
        </Stack>
      </Stack>
      <Typography variant="body2" color="text.secondary" mt={1}>
        {subtitle}
      </Typography>
    </Box>
  );
}
